'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding: 25px;\n'], ['\n  padding: 25px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 300px;\n  margin: auto;\n'], ['\n  width: 100%;\n  max-width: 300px;\n  margin: auto;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject);

var Content = _styledComponents2.default.span(_templateObject2);

var MobileSteps = function MobileSteps(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Content, null, children));
};

MobileSteps.propTypes = {
  children: _propTypes2.default.node
};
exports.default = MobileSteps;